import { useEffect, useState } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import StepContent from '@mui/material/StepContent'
import StepLabel from '@mui/material/StepLabel'
import { Circle } from '@phosphor-icons/react'
import { format } from 'date-fns'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { useFormatMessage } from '@acre/utils'
import { CaseVersionSummary, useGetCaseVersionsQuery } from '@acre/graphql'
import { ColourId } from '@acre/design-system'

import { Tag } from '../../../../../../common/design-system/src/components'
import { StyledStep, StyledStepper } from './VersionNavigation.styles'

const messagePrefix = 'cases.reviewMode.versionHistory'

const VersionNavigation = ({ caseId, disabled }: { caseId: string; disabled: boolean }) => {
  const theme = useTheme()
  const formatMessage = useFormatMessage()
  const navigate = useNavigate()

  const [activeStep, setActiveStep] = useState<number>(0)

  const { data } = useGetCaseVersionsQuery({ variables: { id: caseId } })

  const caseVersions = data?.caseVersions?.cases

  const steps = caseVersions?.map((version: CaseVersionSummary) => {
    return {
      version: version.version,
      date_created: `${version.version_created_at}`,
      // TODO - introduce status once BE ticket is updated to include field
      // status: version.status || CaseStatus.InvalidStatus,
    }
  })

  useEffect(() => {
    if (caseVersions?.length) {
      setActiveStep(caseVersions?.length - 1)
    }
  }, [caseVersions?.length])

  useEffect(() => {
    if (!disabled) {
      navigate(`/cases/${caseId}/review-mode/version/${activeStep + 1}/fact-find`)
    }
  }, [activeStep, caseId, disabled, navigate])

  const stepIcon = <Circle size={12} weight="fill" color={theme.colours.new.baseLightColour} />

  if (disabled) return

  return (
    <Box>
      <Typography variant="h6" fontWeight={700}>
        {formatMessage(`${messagePrefix}.caseHistory`)}
      </Typography>
      <Box mt={1} mb={2}>
        <StyledStepper orientation="vertical" activeStep={activeStep}>
          {steps?.map((step, index) => (
            <StyledStep
              key={`Version${step.version}`}
              expanded={true}
              active={index === activeStep}
              last={index === steps.length - 1}
              onClick={() => setActiveStep(index)}
            >
              <StepLabel icon={stepIcon}>
                {/* TODO - use status once BE ticket is updated to include field */}
                {/* <Tag text={step.label} colourID={STATUS_TAG_COLOUR[step.status as CaseStatus]} /> */}
                <Tag
                  text={<FormattedMessage id={`${messagePrefix}.version`} values={{ version: step.version }} />}
                  colourID={ColourId.Green}
                />
              </StepLabel>
              <StepContent>
                <Typography fontSize="12px">
                  <FormattedMessage
                    id={`${messagePrefix}.transitionedOn`}
                    values={{ date: format(new Date(step.date_created), 'dd.MM.yy') }}
                  />
                </Typography>
              </StepContent>
            </StyledStep>
          ))}
        </StyledStepper>
      </Box>
    </Box>
  )
}

export default VersionNavigation
